module.exports = __webpack_public_path__ + "img/Group 127.d0484b98.jpg";